export const DEFAULT_DATA_LIMIT = 24;
